// src/chains/omax.js - Keep using direct contract calls for now
import { createChainConfig } from './chainConfig';

export const omaxConfig = createChainConfig({
  key: 'omax', 
  chainId: 311,
  name: 'Omax Mainnet',
  rpcUrl: 'https://mainapi.omaxray.com',
  explorerUrl: 'https://omaxscan.com',
  
  // Native token information
  nativeTokenSymbol: 'OMAX',
  nativeTokenName: 'Omax',
  nativeTokenIcon: 'https://coin-images.coingecko.com/coins/images/19853/small/omxlogo.png?1696519276',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x373e4b4E4D328927bc398A9B50e0082C6f91B7bb', // WOMAX on OMAX
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=omax-token&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'omax-token',
  geckoTerminalId: 'omax-chain',
  tokenListUrl: 'https://raw.githubusercontent.com/OMAX-Development/token-list/master/mainnet.tokenlist.json',
  
  // BitDogSwap aggregator address - continue using direct contract calls
  aggregatorAddress: '0x0184a86C8C8178Eb2FD24e69F987cF8a565e4D1f',
  
  // Transaction support
  supportsEIP1559: false,
});